import { ROLES, ROUTE_PATHS, SUBSCRIPTION_STATUS } from '@/constantes';

export const MENU_OPCIONES = [
    {
        nombre: 'Inicio',
        ruta: ROUTE_PATHS.BIENVENIDA,
        icono: 'fa-house',
        roles: [ROLES.ADMINISTRADOR, ROLES.INSTALADOR, ROLES.SUPERADMIN],
    },
    {
        nombre: 'Administrador',
        ruta: ROUTE_PATHS.ADMINISTRADOR,
        icono: 'fa-user-tie',
        roles: [ROLES.ADMINISTRADOR, ROLES.SUPERADMIN],
    },
    {
        nombre: 'Instaladores',
        ruta: ROUTE_PATHS.INSTALADORES,
        icono: 'fa-screwdriver-wrench',
        roles: [ROLES.ADMINISTRADOR, ROLES.SUPERADMIN],
    },
    {
        nombre: 'Cotizaciones',
        ruta: ROUTE_PATHS.COTIZACIONES,
        icono: 'fa-solar-panel',
        roles: [ROLES.ADMINISTRADOR, ROLES.INSTALADOR, ROLES.CLIENTE, ROLES.SUPERADMIN],
    },
    {
        nombre: 'Clientes',
        ruta: ROUTE_PATHS.CLIENTES,
        icono: 'fa-person',
        roles: [ROLES.ADMINISTRADOR, ROLES.INSTALADOR, ROLES.SUPERADMIN],
    },
    {
        nombre: 'Proveedores',
        ruta: ROUTE_PATHS.PROVEEDORES,
        icono: 'fa-shop',
        roles: [ROLES.ADMINISTRADOR, ROLES.INSTALADOR, ROLES.SUPERADMIN],
    },
    {
        nombre: 'Bloqueo',
        ruta: ROUTE_PATHS.MEMBRESIA_PAGO,
        icono: 'fa-lock',
        roles: [],
    },
    {
        nombre: 'Configuración',
        ruta: ROUTE_PATHS.CONFIGURACION,
        icono: 'fa-gear',
        roles: [ROLES.ADMINISTRADOR, ROLES.SUPERADMIN],
    },   
];

export function getMenuPorUsuario(usuario) {
    if (!usuario) return [];

    const { id_rol, suscripcion } = usuario;
    const statusSuscripcion = suscripcion?.status;

    const tieneMembresiaValida = [
        SUBSCRIPTION_STATUS.ACTIVE, 
        SUBSCRIPTION_STATUS.TRIALING
    ].includes(statusSuscripcion);

    const esInstalador = id_rol === ROLES.INSTALADOR;
    const debeEstarBloqueado = esInstalador && !tieneMembresiaValida;

    if (debeEstarBloqueado) {
        return MENU_OPCIONES.filter(opcion => 
            opcion.ruta === ROUTE_PATHS.MEMBRESIA_PAGO
        );
    }

    return MENU_OPCIONES.filter(opcion => {
        const tienePermisoRol = opcion.roles.length === 0 || opcion.roles.includes(id_rol);
        const esRutaPago = opcion.ruta === ROUTE_PATHS.MEMBRESIA_PAGO;

        return tienePermisoRol && !esRutaPago;
    });
}

export function getRolIdByNombre(rolNombre) {
    if (!rolNombre) return null;
    const rolKey = Object.keys(ROLES).find(key => key === rolNombre.toUpperCase());
    return rolKey ? ROLES[rolKey] : null;
}

export function getMenuPorRol(id_rol) {
    return getMenuPorUsuario({ 
        id_rol: id_rol, 
        suscripcion: { status: 'active' } 
    });
}